// Export helpers for Business Analytics reports.
// Supports CSV, XLSX (SheetJS) and PDF (jsPDF + autotable).

import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

/* ---------- CSV ---------- */
function csvEscape(v) {
    const s = v == null ? "" : String(v);
    if (/["\n,]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
    return s;
}

export function downloadCSV(filename, headers, rows) {
    const lines = [headers.map(csvEscape).join(",")];
    rows.forEach((r) => lines.push(r.map(csvEscape).join(",")));
    const blob = new Blob(["\ufeff" + lines.join("\n")], { type: "text/csv;charset=utf-8" });
    triggerDownload(blob, `${filename}.csv`);
}

/* ---------- XLSX ---------- */
export function downloadXLSX(filename, sheetName, headers, rows) {
    const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    triggerDownload(blob, `${filename}.xlsx`);
}

/* ---------- PDF ---------- */
export function downloadPDF(filename, title, subtitle, headers, rows) {
    const doc = new jsPDF({ orientation: rows.length && rows[0].length > 4 ? "landscape" : "portrait", unit: "pt", format: "a4" });
    // Cover header
    doc.setFillColor(16, 26, 58);       // Pout navy
    doc.rect(0, 0, doc.internal.pageSize.width, 70, "F");
    doc.setTextColor(212, 175, 55);     // Pout gold
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.text("Pout Aesthetics", 40, 34);
    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(title, 40, 54);
    doc.setTextColor(60, 60, 60);
    doc.setFontSize(10);
    doc.text(subtitle || "", 40, 92);

    autoTable(doc, {
        head: [headers],
        body: rows.map((r) => r.map((c) => (c == null ? "" : String(c)))),
        startY: 110,
        theme: "grid",
        styles: { font: "helvetica", fontSize: 9, cellPadding: 6, textColor: [30, 30, 30] },
        headStyles: { fillColor: [16, 26, 58], textColor: [212, 175, 55], fontStyle: "bold" },
        alternateRowStyles: { fillColor: [246, 244, 238] },
        margin: { left: 40, right: 40 },
    });

    // Footer
    const pages = doc.getNumberOfPages();
    for (let i = 1; i <= pages; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        doc.setTextColor(120, 120, 120);
        doc.text(`Generated ${new Date().toLocaleString("en-GB")} · Page ${i} of ${pages}`, 40, doc.internal.pageSize.height - 20);
    }
    doc.save(`${filename}.pdf`);
}

/* ---------- glue ---------- */
export function exportReport(format, key, subtitle, report, rows) {
    const filename = `pout-${key}-${new Date().toISOString().slice(0, 10)}`;
    if (format === "csv")  return downloadCSV(filename, report.headers, rows);
    if (format === "xlsx") return downloadXLSX(filename, report.title, report.headers, rows);
    if (format === "pdf")  return downloadPDF(filename, report.title, subtitle, report.headers, rows);
    throw new Error(`unknown format: ${format}`);
}

function triggerDownload(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = filename;
    document.body.appendChild(a); a.click();
    setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
}
